import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 16a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-0"}],["path",{"d":"M14 19a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M10 7.5a4.5 4.5 0 1 0 9 0a4.5 4.5 0 1 0 -9 0","key":"svg-2"}]]

const IconChartBubble = createReactComponent('outline', 'chart-bubble', 'ChartBubble', __iconNode);

export default IconChartBubble;